import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
const Label = ({ children, className, helpText, htmlFor, required, renderAs, }) => {
    const Component = renderAs || 'label';
    return (_jsxs(Component, { className: classNames('form-label', className), htmlFor: htmlFor, children: [children, required ? '*' : '', helpText && (_jsxs(_Fragment, { children: [_jsx("br", {}), _jsx("small", { children: _jsx("i", { children: helpText }) })] }))] }));
};
export default Label;
